<template>
  <div class="s-container" v-if="results.length > 0">
    <div class="s-results">
      <div class="s-input-wrapper">
        <input class="searcher" type="text" v-model="query" placeholder="Buscar" />
      </div>
      <div class="s-result-placeholder" v-if="loading">
        <div class="placeholder-item" v-for="item in 1" :key="item">
          <div></div>
        </div>
      </div>
      <div v-if="!loading && filterResults.length">
        <div class="s-result-items" v-for="(item, key) of filterResults" :key="key">
          <v-card @click="navigate(item.tipo, item.ident)" class="card-with-margin">
            <v-row>
              <v-col class="col-6">
                <v-card-title class="custom-vcard">
                  <h3 class="custom-h3">{{ item.titulo }}</h3>
                  <h5 class="category">{{ item.tipo }} </h5>
                </v-card-title>
              </v-col>
              <v-col class="col-6" align="center">
                <v-img :src="item.img" height="5em" width="5em">
                </v-img>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </div>
      <div class="s-status-message" v-if="!loading && message">
        <span>{{ message }}</span>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import HitoDataService from "../../services/HitoDataService";
import PDIDataService from "../../services/PDIDataService";
import NewsDataService from "../../services/NewsDataService";
import RutasDataService from "../../services/RutasDataService";
export default {
  name: "Search",
  data() {
    return {
      query: "",
      results: [],
      filterResults: [],
      loading: false,
      message: "",
    };
  },
  delimiters: ["[[", "]]"],
  watch: {
    query() {
      if (this.query.length >= 3) {
        this.searchItems();
        this.loading = false;
      }
      if (this.query.length < 3) {
        this.loading = true;
        this.filterResults = [];
      }
    },
  },
  async mounted() {
    await this.getHitos();
    await this.getPDIs();
    await this.getRutas();
    await this.getNews();
  },
  methods: {
    navigate(tipo, ident) {
      var url = "";
      switch (tipo) {
        case "Hito":
          url = this.$baseWebUrl + "hitos/" + ident;
          break;
        case "PDI":
          url = this.$baseWebUrl + "punto-de-interes/" + ident;
          break;
        case "Ruta":
          url = this.$baseWebUrl + "rutas/" + ident;
          break;
        case "Noticia":
          url = this.$baseWebUrl + "news/" + ident;
          break;
        default:
          break;
      }
      window.location.href = url;
    },
    quitarAcentos(cadena) {
      const acentos = {
        á: "a",
        é: "e",
        í: "i",
        ó: "o",
        ú: "u",
        Á: "A",
        É: "E",
        Í: "I",
        Ó: "O",
        Ú: "U",
      };
      return cadena
        .split("")
        .map((letra) => acentos[letra] || letra)
        .join("")
        .toString();
    },
    searchItems() {
      this.message = "";
      this.filterResults = [];
      this.results.forEach((r) => {
        if (
          this.quitarAcentos(r.titulo.toLowerCase()).includes(
            this.quitarAcentos(this.query.toLowerCase())
          )
        )
          this.filterResults.push(r);
      });

      if (this.filterResults.length == 0)
        this.message = "No se han encontrado coincidencias";
      else this.loading = false;
    },
    async getHitos() {
      var obj = await HitoDataService.getAll();
      var elems = obj.data.data;
      elems.forEach((element) => {
        this.results.push({
          tipo: "Hito",
          titulo: element.attributes.Titulo,
          ident: element.id,
          img: this.$baseStrapiUrl + element.attributes.Imagen.data.attributes.url
        });
      });
    },
    async getNews() {
      var obj = await NewsDataService.getAll();
      var elems = obj.data.data;
      elems.forEach((element) => {
        this.results.push({
          tipo: "Noticia",
          titulo: element.attributes.Titulo,
          ident: element.id,
          img: this.$baseStrapiUrl + element.attributes.Imagen.data.attributes.url
        });
      });
    },
    async getPDIs() {
      var obj = await PDIDataService.getAll();
      var elems = obj.data.data;
      elems.forEach((element) => {
        this.results.push({
          tipo: "PDI",
          titulo: element.attributes.Titulo,
          ident: element.id,
          img: this.$baseStrapiUrl + element.attributes.ImagenPortada.data.attributes.url
        });
      });
    },
    async getRutas() {
      var obj = await RutasDataService.getAll();
      var elems = obj.data.data;
      elems.forEach((element) => {
        this.results.push({
          tipo: "Ruta",
          titulo: element.attributes.Titulo,
          ident: element.id,
          img: this.$baseStrapiUrl + element.attributes.Imagen.data.attributes.url
        });
      });
    },
  },
};
</script>

<style scopped>
.searcher {
  height: fit-content;
}

.s-container,
.s-results {
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content;
  width: 100%;
}

.s-container {
  grid-gap: 5px;
  border-radius: 0.1em;
}

.s-input-wrapper>input {
  height: 50px;
  width: 100%;
  background-color: #efefef;
  font-size: x-large;
  font-family: "Amatic SC", cursive;
  padding: 2px 5px;
}

.s-result-items>div,
.placeholder-item,
.s-status-message {
  font-size: 2rem;
  background-color: rgb(255, 255, 255, 0.9);
  backdrop-filter: blur(10%);
  padding: 4px 5px;
  min-height: 30px;
  display: flex;
  justify-content: space-between;

}

.s-result-items>div:nth-child(n + 2) {
  border-top: 2px solid #d8d8d8;

}

.category {
  font-style: italic;
  color: rgb(158, 158, 158);
  font-size: medium;
  font-weight: 600;
  text-align: center;

}

.placeholder-item>div {
  position: relative;
  width: 100%;
  height: 22px;
  padding: 5px;
  border-radius: 4px;
  background: rgb(225, 225, 225);
  background: linear-gradient(90deg,
      rgba(227, 227, 227, 1) 0%,
      rgba(207, 207, 207, 1) 7%,
      rgba(207, 207, 207, 1) 13%,
      rgba(227, 227, 227, 1) 25%);
  background-size: 900%;
  background-position: 100% 0%;
  animation: placeholder-animation 1s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;

}

.s-status-message>p {
  width: 100%;
  text-align: center;

}

@keyframes placeholder-animation {
  0% {
    background-position: 100% 0%;
  }

  50% {
    background-position: 50% 0%;
  }

  100% {
    background-position: 0% 0%;
  }
}

.card-with-margin {
  margin-top: 4px;
}

.custom-h3 {
  font-size: 1rem;
}

/* Estilos para dispositivos con pantalla de hasta 600px de ancho */
@media (max-width: 600px) {
  .custom-h3 {
    font-size: 0.7rem;
  }

  .custom-vcard {
    margin: 0;
    padding: 0 !important;
  }

  .category {
    font-size: 1rem;
  }

}
</style>
